import { Component, Input, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { CommonModule, DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { ParticipantFormData } from '../../../interfaces/referralSections.interface';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { performValidation } from '../../../shared/utils/validation.util';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { RADIO_BOOLEAN_YES_NO_OPTIONS, RADIO_YES_NO_OPTIONS, STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { UploadComponent } from '../../../shared/components/upload/upload.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { differenceInCalendarDays } from 'date-fns';
import { DateTimeFormatterService } from '../../../shared/utils/date-time-formatter.service';
import { LookupValueItem } from '../../../interfaces/lookup.interface';
import { CdpapService } from '../../../services/cdpap.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { DatePickerComponent } from '../../../shared/components/date-picker/date-picker.component';
import { PopupDialogComponent } from '../../../shared/components/popup-dialog/popup-dialog.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { CdpapFormComponent } from '../../../shared/components/cdpap-form/cdpap-form.component';
import { MultiselectComponent } from '../../../shared/components/multiselect/multiselect.component';
import { DropdownSelectComponent } from '../../../shared/components/dropdown-select/dropdown-select.component'; 
import { LeadDetailsService } from '../../../services/lead-details.service';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';
import { PPLRadioFocusDirective } from '../../../shared/directives/ppl-radio-focus.directive';
import { LoginDetailsComponent } from '../../lead-details/login-details/login-details.component';
import { MEMBER_VIEW_PAGE_IDS } from '../../../shared/constants/page.constants';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../shared/authorization/authorization.service';
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { RoutingService } from '../../../shared/services/routing.service';

@Component({
  selector: 'ppl-participant-info',
  standalone: true,
  imports: [
    NzFormModule,
    FormsModule,
    ReactiveFormsModule,
    NzGridModule,
    NzCardModule,
    NzRadioModule,
    NzDatePickerModule,
    CommonModule,
    NzToolTipModule,
    NzIconModule,
    NzInputModule,
    NzSelectModule,
    UploadComponent,
    NzDividerModule,
    PopupDialogComponent,
    ButtonComponent,
    CdpapFormComponent,
    MultiselectComponent,
    DatePickerComponent,
    AutoFocusHeaderDirective,
    DropdownSelectComponent,
    PPLRadioFocusDirective,
    LoginDetailsComponent,
    AuthorizeDirective],
  templateUrl: './participant-information.component.html',
  styleUrl: './participant-information.component.css',
})
export class ParticipantInformationComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  @Input() mode = 'edit';
  @Input() source?: string = '';
  filledInfo: ParticipantFormData = {};
  private navigationSubscription: Subscription | undefined;
  infoForm!: FormGroup;
  ssnVisible = false;
  gender: any[] = [];
  formHasBeenFilled = false;
  radioOptions = RADIO_YES_NO_OPTIONS;
  radioBooleanOptions = RADIO_BOOLEAN_YES_NO_OPTIONS;
  ssnWith9 = false;
  flow: string | null = '';
  waiver: any[] = [];
  fromInterest = true;
  liveSsnAnnouncement = '';
  applicationSourceList = [ {
    lkpValueName: 'File Manual Entry',
    lkpValueCode: 'FML'
  },
  {
    lkpValueName: 'Self',
    lkpValueCode: 'Self'
  },
  {
    lkpValueName: 'External MCO',
    lkpValueCode: 'RMCO'
  },
  {
    lkpValueName: 'External LDSS',
    lkpValueCode: 'RLDSS'
  },
  {
    lkpValueName: 'Internal',
    lkpValueCode: 'INT'
  },
 ];
  isApplicationSourceFixed = false;
  state: any;
  contactStsReasonLkpList: LookupValueItem[] = [];
  states: any[] = [];
  fiEntries: any;
  mcoEntries: any;
  relationshipOptions: any;
  eyeColors: any;
  hairColors: any;
  raceOptions: any;
  taxExemptOptions: any;
  formReadonly = false;
  services: any;
  ldssOfficeValues: LookupValueItem[] =[];
  currentFIValues: LookupValueItem[] = [];
  disabledDate: any;
  isMobile = window.innerWidth < 768;
  today = new Date();
  yesterday: any;
  minStartDate?: Date;
  maxEndDate?: Date;
  canUnmaskSSN = false;
  canUnmaskSelfSSN = false;
  tpsCountries: LookupValueItem[] = [];
  program: any;
  selectedLead: any;
  hasLoginData = false;
  loginRecords: { userRoleActive?: string; azureUUID?: string; userId?: string }[] = [];
  isLDSSUser = false;
  isMCOUser = false;
  isPA = false;
  isPageAccessLoaded = false;
  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];
  tabId = 'MEMBER_INFORMATION';
  @ViewChild('confirmationDialog') confirmationDialog!: TemplateRef<object>;
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private sectionsService: SectionsService,
    private referralDataService: ReferralDataService,
    private datePipe: DatePipe,
    private dateTimeFormatterService: DateTimeFormatterService,
    private cdpapService: CdpapService,
    private storageService: StorageService,
    private leadDetailsService: LeadDetailsService,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService,
    private dialogSvc: DialogService,
    private router: RoutingService,
  ) {
    super();
  }

  ngOnInit(): void {
    console.log("pageId, ", this.pageId, this.tabId);
    const program = this.userService.getSelectedProgram();
    this.program = program;
    this.selectedLead = this.userService.getSelectedLead();
    const userDetails = this.userService.getUserDetails();
    this.ldssOfficeValues = this.getLookup('LDSS_Office');
    this.isLDSSUser = userDetails?.usertype_lkp?.toLowerCase() === 'ldss';
    this.isMCOUser = userDetails?.usertype_lkp?.toLowerCase() === 'mco';
    this.canUnmaskSSN = this.userService.isSelectedRole(['PPL Admin', 'BAVAdmin', 'Compliance']);
    this.canUnmaskSelfSSN = userDetails?.programs.find(pr => pr.program_code === program?.program_code)?.referenceId === this.userService.getSelectedLead();
    this.infoForm = this.fb.group({
      fname: [''],
      lname: [''],
      dob: [null],
      gender: [null],
      SSN: [''],
    });
    this.flow = this.sectionsService.getFlow()!;
    const providerType = this.sectionsService.getEnrollmentType();
    if (Array.isArray(providerType) && providerType.includes('provider')) {
      this.isPA = true;
    }
    const associationFlows = ['employer', 'authRepresentative', 'provider', 'vendor', 'contractor', 'legalGuardian', 'poa'];
    console.log("this.flow", this.flow);
    this.lookupService.getOrgData(program?.program_code ?? '',).subscribe((data: any) => {
      if (data.status == 200) {
        this.fiEntries = data.responsedata.filter((item: any) => item.orgTypeLookup === 'FI');
        this.mcoEntries = data.responsedata.filter((item: any) => item.orgTypeLookup === 'MCO');
        if (this.flow === 'referral') {
          this.applyMcoDefaultForUserType(userDetails?.userOrgName);
        }
      }
    })
    if (this.flow == 'participants') {
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('CIN', this.fb.control(''));
    }
    else if (this.flow == 'providers') {
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('isProvidingServices', this.fb.control(null));
      this.infoForm.addControl('showOnDirectory', this.fb.control(null));
      this.infoForm.addControl('servicesRendered', this.fb.control(null));
    }
    else if (this.flow == 'referral') {
      const userOrgName = userDetails?.userOrgName;
      const ldssId = this.isLDSSUser ? this.ldssOfficeValues.filter((ldssOfc:any)=>{
        return ldssOfc.lkpValueName === userOrgName;
      }).map((ldss:any)=> ldss.lkpValueCode) : [];
      const ldssValue = this.isLDSSUser ? ldssId[0] : '';
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('waiver', this.fb.control(''));
      const applicationSourceForUserType = this.isMCOUser ? 'RMCO' : this.isLDSSUser ? 'RLDSS' : 'INT';
      this.infoForm.addControl('applicationSource', this.fb.control(applicationSourceForUserType));
      this.isApplicationSourceFixed = true;
      this.referralDataService.setReferralFormData('applicationSourceFixed', true);
      this.infoForm.addControl('CIN', this.fb.control(''));
      this.infoForm.addControl('CPI', this.fb.control(''));
      this.infoForm.addControl('mcoOrgName', this.fb.control({ value: '', disabled: this.isLDSSUser || this.isMCOUser }));
      this.infoForm.addControl('fiOrgName', this.fb.control('Public Partnerships'));
      this.infoForm.addControl('eligiblityStartDate', this.fb.control(null));
      this.infoForm.addControl('eligiblityEndDate', this.fb.control(null));
      this.infoForm.addControl('ldssOffice', this.fb.control({ value: ldssValue, disabled: this.isLDSSUser || this.isMCOUser }));
      this.infoForm.addControl('contactStsReasonLkp', this.fb.control(''));
      this.infoForm.addControl('pdrFirstName', this.fb.control(''));
      this.infoForm.addControl('pdrLastName', this.fb.control(''));
      this.infoForm.addControl('pdrRelation', this.fb.control(''));
      this.infoForm.addControl('pdrPhone', this.fb.control(''));
    }
    else if (this.flow == 'participantEnrollment') {
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('waiver', this.fb.control(''));
      this.infoForm.addControl('mcoOrgName', this.fb.control(''));
      this.infoForm.addControl('fiOrgName', this.fb.control('Public Partnerships'));
      const applicationSourceForUserType = this.isMCOUser ? 'RMCO' : this.isLDSSUser ? 'RLDSS' : 'INT';
      this.infoForm.addControl('applicationSource', this.fb.control(applicationSourceForUserType));
      this.isApplicationSourceFixed = true;
      this.referralDataService.setReferralFormData('applicationSourceFixed', true);
      this.infoForm.addControl('eligiblityStartDate', this.fb.control(null));
      this.infoForm.addControl('eligiblityEndDate', this.fb.control(null));
      this.infoForm.addControl('CIN', this.fb.control(''));
      this.infoForm.addControl('CPI', this.fb.control(''));
      this.infoForm.addControl('ldssOffice', this.fb.control(''));
      this.infoForm.addControl('currentFI', this.fb.control(''));
      this.infoForm.addControl('referralId', this.fb.control(''));
      this.infoForm.addControl('contactStsReasonLkp', this.fb.control(''));
      this.infoForm.addControl('contactStsComments', this.fb.control(''));
      this.infoForm.addControl('pdrFirstName', this.fb.control(''));
      this.infoForm.addControl('pdrLastName', this.fb.control(''));
      this.infoForm.addControl('pdrRelation', this.fb.control(''));
      this.infoForm.addControl('pdrPhone', this.fb.control(''));
    }
    else {
      this.infoForm.addControl('businessName', this.fb.control(''));
      this.infoForm.addControl('mname', this.fb.control(''));
      this.infoForm.addControl('maiden_name', this.fb.control(''));
      this.infoForm.addControl('CIN', this.fb.control(''));
      this.infoForm.addControl('EIN', this.fb.control(''));
      this.infoForm.addControl('isProvidingServices', this.fb.control(null));
      this.infoForm.addControl('waiver', this.fb.control(''));
      this.infoForm.addControl('relationToParticipant', this.fb.control(''));
      this.infoForm.addControl('NPI', this.fb.control(''));
      this.infoForm.addControl('race', this.fb.control(''));
      this.infoForm.addControl('heightFeet', this.fb.control(''));
      this.infoForm.addControl('heightInches', this.fb.control(''));
      this.infoForm.addControl('weight', this.fb.control(''));
      this.infoForm.addControl('eyeColor', this.fb.control(''));
      this.infoForm.addControl('hairColor', this.fb.control(''));
      this.infoForm.addControl('birthCity', this.fb.control(''));
      this.infoForm.addControl('birthState', this.fb.control(''));
      this.infoForm.addControl('birthCountry', this.fb.control(''));
      this.infoForm.addControl('showOnDirectory', this.fb.control(''));
      this.infoForm.addControl('mcoOrgName', this.fb.control(''));
      this.infoForm.addControl('fiOrgName', this.fb.control(''));
      this.infoForm.addControl('taxExempt', this.fb.control(''));
      this.infoForm.addControl('nprftDocumentationReceived', this.fb.control(''));
      this.infoForm.addControl('yearsInState', this.fb.control(''));
      this.infoForm.addControl('isSnapReceived', this.fb.control(null));
      this.infoForm.addControl('isTanfReceived', this.fb.control(null));
      this.infoForm.addControl('isSsiReceived', this.fb.control(null));
      this.infoForm.addControl('isUnemployed', this.fb.control(null));
      this.infoForm.addControl('isVeteran', this.fb.control(null));
      this.infoForm.addControl('isDisabilityComp', this.fb.control(null));
      this.infoForm.addControl('tempProtectedSts', this.fb.control(''));
      this.infoForm.addControl('tpsCountryLkp', this.fb.control(''));
      this.infoForm.addControl('isWotcCertified', this.fb.control({ value: null, disabled: true }));
    }
    this.formReadonly = this.referralDataService.getAssociationsEditable();

    if (this.formReadonly) {
      this.infoForm.disable()
    } else {
      this.infoForm.enable()
      if (this.flow === 'referral' && (this.isLDSSUser || this.isMCOUser)) {
        this.infoForm.get('ldssOffice')?.disable({ emitEvent: false });
        this.infoForm.get('mcoOrgName')?.disable({ emitEvent: false });
      }
    }

    const today = new Date();
    this.yesterday = new Date(today);
    this.yesterday.setDate(today.getDate() - 1);
    this.disabledDate = (current: Date): boolean => {
      return differenceInCalendarDays(current, today) >= 0;
    }
    this.states = this.getLookup("STATE");
    this.relationshipOptions = this.getLookup('Relationship');
    this.eyeColors = this.getLookup('Eye Color');
    this.hairColors = this.getLookup('Hair Color');
    this.raceOptions = this.getLookup('Race');
    this.taxExemptOptions = this.getLookup('Tax Exemption');
    this.services = this.getLookup('Service_Type');
    this.currentFIValues = this.getLookup('CFI');
    this.contactStsReasonLkpList = this.getLookup('contact_status_reason_lkp');
    this.tpsCountries = this.getLookup('Temporary Protected Status Country');
    this.setPageAccess();

    this.navigationSubscription = this.infoForm.valueChanges.subscribe(
      () => {
        // if (!this.formHasBeenFilled && this.hasAnyValue(this.infoForm)) {
        const hasValue = this.hasAnyValueInForm(this.infoForm);
        this.formHasBeenFilled = hasValue;
        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isInfoFormUpdated',
            this.formHasBeenFilled
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isInfoFormUpdated',
            this.formHasBeenFilled
          );
        }

        // this.infoForm.value.dob =
        //   this.datePipe.transform(this.infoForm.value.dob, 'MM/dd/yyyy') || '';
        if (this.infoForm.value.dob) {
          this.infoForm.patchValue({dob: this.datePipe.transform(this.infoForm.value.dob, 'MM/dd/yyyy') || ''}, { emitEvent: false });
        }
        if (this.infoForm.value.eligiblityStartDate && this.infoForm.value.eligiblityStartDate instanceof Date) {
          this.infoForm.patchValue({eligiblityStartDate: this.dateTimeFormatterService.formatDateToString(this.infoForm.value.eligiblityStartDate as Date)}, {emitEvent: false});
        }
        if (this.infoForm.value.eligiblityEndDate && this.infoForm.value.eligiblityEndDate instanceof Date) {
          this.infoForm.patchValue({eligiblityEndDate: this.dateTimeFormatterService.formatDateToString(this.infoForm.value.eligiblityEndDate as Date)}, {emitEvent: false});
        }
        if (this.flow === 'referral' || this.flow === 'participantEnrollment') {
          const rawValue = this.infoForm.getRawValue();
          let mcoOrgId = null;
          let fiOrgId = null;
          let CIN = null;
          let CPI = null;
          if (rawValue.mcoOrgName) {
            mcoOrgId = this.mcoEntries?.find((entry: any) => entry.orgName === rawValue.mcoOrgName)?.orgId || null;
          }
          if (rawValue.fiOrgName) {
            fiOrgId = this.fiEntries?.find((entry: any) => entry.orgName === rawValue.fiOrgName)?.orgId || null;
          }
          if(rawValue.CIN) {
            CIN = rawValue.CIN.toUpperCase();
          }
          if(rawValue.CPI) {
            CPI = rawValue.CPI.toUpperCase();
          }
          const formDataModified = {
            ...rawValue,
            mcoOrgId,
            fiOrgId,
            CIN,
            CPI
          };
          this.referralDataService.setReferralFormData(
            'infoData',
            formDataModified
          );
        } else {
          if (!associationFlows.includes(this.flow ?? '')) {
            this.referralDataService.setReferralFormData(
              'infoData',
              this.infoForm.value
            );
          } else {
            this.referralDataService.setAssociationFormData(
              'infoData',
              this.infoForm.value
            );
          }
        }
        this.referralDataService.setChanged(!hasValue ? false : this.infoForm.dirty);
        if (!associationFlows.includes(this.flow ?? '')) {
          this.referralDataService.setReferralFormData(
            'isInfoFormDirty',
            !hasValue ? false : this.infoForm.dirty
          );
        } else {
          this.referralDataService.setAssociationFormData(
            'isInfoFormDirty',
            !hasValue ? false : this.infoForm.dirty
          );
        }
        if (
          this.infoForm.value.isSnapReceived !== null && this.infoForm.value.isSnapReceived !== undefined ||
          this.infoForm.value.isTanfReceived !== null && this.infoForm.value.isTanfReceived !== undefined ||
          this.infoForm.value.isSsiReceived !== null && this.infoForm.value.isSsiReceived !== undefined ||
          this.infoForm.value.isUnemployed !== null && this.infoForm.value.isUnemployed !== undefined ||
          this.infoForm.value.isVeteran !== null && this.infoForm.value.isVeteran !== undefined
        ) {
          this.infoForm.get('isWotcCertified')?.enable({emitEvent: false});
        }
        else{
          this.infoForm.get('isWotcCertified')?.disable({emitEvent: false});
        }
      }
    );

    this.infoForm.get('eligiblityEndDate')?.valueChanges.subscribe(() => {
      this.updateMinStartDate();
    });
    this.infoForm.get('eligiblityStartDate')?.valueChanges.subscribe(() => {
      this.updateMaxEndDate();
    });
    this.infoForm.get('tempProtectedSts')?.valueChanges.subscribe((value: any) => {
      if (value === 'No') {
        this.infoForm.get('tpsCountryLkp')?.setValue(null);
      }
    });

    if (!associationFlows.includes(this.flow ?? '')) {
      console.log('getting data in component')
      if (this.referralDataService.getReferralFormData().infoData) {
        this.filledInfo = this.referralDataService.getReferralFormData().infoData;
        this.isApplicationSourceFixed = this.referralDataService.getReferralFormData().applicationSourceFixed ?? false;
        this.state = this.referralDataService.getReferralFormData()?.state?.state;
        if (this.mode === 'edit' && (this.canUnmaskSSN || this.canUnmaskSelfSSN) && this.filledInfo?.SSN?.startsWith('XXX')) {
          const payload = this.getUnMaskAPIPayload('SSN');
          this.leadDetailsService.unmaskIdentifier(program?.program_code || '', payload).subscribe((res: any) => {
              this.filledInfo.SSN = res.responsedata || this.filledInfo.SSN;
              this.infoForm.patchValue(this.filledInfo);
          });
        }
        this.infoForm.patchValue(this.filledInfo);
      }
    } else {
      console.log('patching form');
      if (this.referralDataService.getAssociationFormData().infoData) {
        this.filledInfo = this.referralDataService.getAssociationFormData().infoData;
        this.state = this.referralDataService.getAssociationFormData()?.state?.state;
        this.infoForm.patchValue(this.filledInfo);
      }
    }

    this.waiver = this.getLookup('Waiver');
    let steps: any;
    if (this.flow === 'providerEnrollment') {
      steps = this.sectionsService.getProviderSectionData(
        program?.program_code,
        STATIC_DATA.PARTICIPANT_INFO
      );
      this.secData = steps;
    } else {
      steps = this.sectionsService.getSectionData(
        program?.program_code,
        this.source
      );
      this.secData = steps[STATIC_DATA.PARTICIPANT_INFO];
    }

    if (associationFlows.includes(this.flow ?? '')) {
      this.referralDataService.associationSaveClicked.subscribe(() => {
        
        this.validationErrors = performValidation(
          this.infoForm.getRawValue(),
          this.secData,
          'Next',
          undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType()
        );
        if (this.flow === 'provider' && this.referralDataService?.referralFormData?.infoData && (this.infoForm.value.relationToParticipant == 'PRSP')) {
          const dob = this.dateTimeFormatterService.formatStringToDate(this.referralDataService?.referralFormData?.infoData?.dob);
          if (this.getAge(dob) < 21) {
            this.validationErrors['relationToParticipant'] = "Parent cannot be a Personal Assistant to an underaged consumer";
          }
        }
        if (this.flow === 'provider' && this.referralDataService?.referralFormData?.infoData && (this.infoForm.value.relationToParticipant == 'SPSE')) {
            this.validationErrors['relationToParticipant'] = "Spouse cannot be a Personal Assistant";
        }
        this.referralDataService.setError(this.validationErrors);
        this.referralDataService.setAssociationFormData(
          'isInfoFormValid',
          Object.keys(this.validationErrors).length == 0
        );
      });
    }

    this.gender = this.getLookup('Gender');
    this.infoForm.get('SSN')?.valueChanges.subscribe((value) => {
      this.checkSSN(value);
    });

    if (associationFlows.includes(this.flow ?? '')) {
      const filledData = this.referralDataService.getAssociationDetails(
        'infoData'
      )!;
      if (filledData) {
        this.infoForm.patchValue(filledData);
      }
    }

    if (this.flow == 'referral' || this.flow === 'participantEnrollment') {
        this.fromInterest = false;
    }

    if (((this.flow == 'referral' && this.userService.getLeadEntry() == 'referral') || this.flow === 'participantEnrollment' || this.flow === 'providerEnrollment') && !this.referralDataService.getReferralFormData().infoData) {
      const filledData = this.referralDataService.getReferralDetails(
        'infoData', this.flow
      )!;
      if (filledData) {
        if (filledData.applicationSource) {
          const matched = this.applicationSourceList.find(
            (s) => s.lkpValueName === filledData.applicationSource
          );
          if (matched) {
            filledData.applicationSource = matched.lkpValueCode;
          }
          const isInDropdown = this.applicationSourceList.some(
            (s) => s.lkpValueCode === filledData.applicationSource
          );
          if (this.flow == 'referral' || !isInDropdown || (this.flow === 'participantEnrollment' && filledData?.referralId)) {
            this.isApplicationSourceFixed = true;
            this.referralDataService.setReferralFormData('applicationSourceFixed', true);
          }
        }
        this.infoForm.patchValue(filledData);
      }
      this.referralDataService.setReferralFormData('stage', filledData.applicationStage);
    }

    this.referralDataService.nextClicked.subscribe((val: any) => {
      if (val === STATIC_DATA.PARTICIPANT_INFO) {
        this.validationErrors = performValidation(
          this.infoForm.getRawValue(),
          this.secData,
          'Next',
          undefined, undefined, this.sectionsService.getFlow(), this.sectionsService.getEnrollmentType()
        );
        if (
          (this.infoForm.value.isSnapReceived !== null && this.infoForm.value.isSnapReceived !== undefined ||
          this.infoForm.value.isTanfReceived !== null && this.infoForm.value.isTanfReceived !== undefined ||
          this.infoForm.value.isSsiReceived !== null && this.infoForm.value.isSsiReceived !== undefined ||
          this.infoForm.value.isUnemployed !== null && this.infoForm.value.isUnemployed !== undefined ||
          this.infoForm.value.isVeteran !== null && this.infoForm.value.isVeteran !== undefined) && !this.infoForm.value.isWotcCertified
        ) {
            this.validationErrors['isWotcCertified'] = "Selecting the checkbox is mandatory if at least one question has been answered";
        }
        else{
          delete this.validationErrors['isWotcCertified'];
        }
        this.referralDataService.setError(this.validationErrors);
      }
    });

    this.cdpapService.cdPapFormValueChangeSub$.pipe().subscribe(v => {
      this.infoForm.get('fiOrgName')!.setValue(v);
    })
  }

  private applyMcoDefaultForUserType(userOrgName: any): void {
    const mcoControl = this.infoForm.get('mcoOrgName');
    if (!mcoControl) {
      return;
    }
    if (this.isMCOUser) {
      const userMco = this.mcoEntries?.find((mco: any) => mco.orgName === userOrgName);
      if (userMco) {
        mcoControl.setValue(userMco.orgName, { emitEvent: false });
        mcoControl.disable({ emitEvent: false });
      }
    } else if (this.isLDSSUser) {
      const nyMedicaid = this.mcoEntries?.find((mco: any) => mco.orgName === 'New York State Medicaid');
      if (nyMedicaid) {
        mcoControl.setValue(nyMedicaid.orgName, { emitEvent: false });
        mcoControl.disable({ emitEvent: false });
      }
    }
  }

  getUnMaskAPIPayload(identifierType: string){
    const program = this.userService.getSelectedProgram();
    let userType = '';
    let userCategory = '';
    let selectedLead = '';
    selectedLead = this.userService.getSelectedLead() || '';
    if (this.flow === STATIC_DATA.REFERRAL){
      userType = 'participant';
      userCategory = STATIC_DATA.REFERRAL;
    }
    else if(this.flow == STATIC_DATA.PARTICIPANT_ENROLLMENT){
      userType = 'participant';
      userCategory = 'enrollment';
    }
    else if(this.flow == STATIC_DATA.PROVIDER_ENROLLMENT){
      userType = 'provider';
      userCategory = 'enrollment';
    }
    else{
      userType = this.flow || '';
      userCategory = 'lead';
    }

    return {
            "programCode": program?.program_code,
            "identifier": selectedLead,
            "source": 'PPL@Home',
            "identifierType": identifierType,
            "userType": userType,
            "userCategory": userCategory
           };
  }

  openCDPAPPopup() {
    this.cdpapService.openPopup();
  }

  toggleSSN(): void {
    this.ssnVisible = !this.ssnVisible;
    const ssnValue = this.infoForm.get('SSN')?.value || '';
    if (this.ssnVisible && ssnValue) {
      if (ssnValue.includes('X') || ssnValue.includes('x')) {
        const last4 = ssnValue.slice(-4);
        this.liveSsnAnnouncement = `SSN ending in ${last4}`;
      } else {
        this.liveSsnAnnouncement = `SSN: ${ssnValue}`;
      }
    } else {
      this.liveSsnAnnouncement = '';
    }
  }
  
  get isProvidingServicesSelected(): boolean {
    return !!this.infoForm.get('isProvidingServices')?.value;
  }

  updateMinStartDate(): void {
    const eligiblityEndDate = this.infoForm.get('eligiblityEndDate')?.value;
    if (eligiblityEndDate instanceof Date) {
      const nextDay = new Date(eligiblityEndDate);
      nextDay.setDate(nextDay.getDate() - 1);
      this.minStartDate = nextDay;
    } else {
      this.minStartDate = undefined;
    }
  }

  updateMaxEndDate(): void {
    const eligiblityStartDate = this.infoForm.get('eligiblityStartDate')?.value;
    if (eligiblityStartDate instanceof Date) {
      const nextDay = new Date(eligiblityStartDate);
      nextDay.setDate(nextDay.getDate() + 1);
      this.maxEndDate = nextDay;
    } else {
      this.maxEndDate = undefined;
    }
  }

  checkSSN(value: string): void {
    if (value && value.startsWith('9')) {
      this.ssnWith9 = true;
    } else {
      this.ssnWith9 = false;
    }
  }

  // hasAnyValue(form: FormGroup): boolean {
  //   return Object.values(form.controls).some(control => control?.value?.trim() !== undefined && control?.value?.trim() !== '' && control?.value?.trim() !== null);
  // }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if (!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.program?.program_code, this.pageId, 'DETAIL').subscribe({
        next: () => {
          this.isPageAccessLoaded = true;
        },
        error: () => {
          this.isPageAccessLoaded = true;
        }
      });
    } else {
      this.isPageAccessLoaded = true;
    }
  }

  limitDigits(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if(value.length > 9) {
      value = value.slice(0,9);
    }

    event.target.value = value;
    this.infoForm.get('SSN')?.setValue(value);
  }

  getAge(DOB: Date) {
    var today = new Date();
    var birthDate = DOB;
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  getBooleanLabel(value: boolean | string | null | undefined): string {
    const normalizedValue =
      value === 'true' || value === true
        ? true
        : value === 'false' || value === false
        ? false
        : null;
  
    return this.radioBooleanOptions.find(opt => opt.value === normalizedValue)?.label || '';
  }

  disabledStartDate = (startValue: Date): boolean => {
    const datePickerValue = this.infoForm.get('eligiblityEndDate')?.value;
    const endDate = typeof datePickerValue === 'string' ? new Date(datePickerValue) : datePickerValue;
    if (!startValue || !endDate) {
      return false;
    }
    return startValue.getTime() > endDate.getTime();
  };

  disabledEndDate = (endValue: Date): boolean => {
    const datePickerValue = this.infoForm.get('eligiblityStartDate')?.value;
    const startDate = typeof datePickerValue === 'string' ? new Date(datePickerValue) : datePickerValue;
    if (!endValue || !startDate) {
      return false;
    }
    return endValue.getTime() <= startDate.getTime();
  };

  getApplicationSourceDisplayValue(): string {
    const code = this.infoForm.get('applicationSource')?.value;
    const match = this.applicationSourceList.find(s => s.lkpValueCode === code);
    return match ? match.lkpValueName : (code || '');
  }

  getProspectiveDRDisplayValue(data: ParticipantFormData): string {
    const name = [data?.pdrFirstName, data?.pdrLastName].filter(Boolean).join(' ');
    const relationship = data?.pdrRelation
      ? this.getLookupValue(this.relationshipOptions, data.pdrRelation)
      : '';
    const base = (name && relationship) ? `${name} (${relationship})` : (name || relationship || '');
    const phone = data?.pdrPhone;
    return [base, phone].filter(Boolean).join(' – ');
  }

  canInactivateAssociation(): boolean {
    return (
      this.flow === 'providerEnrollment' &&
      this.userService.isSelectedRole(['PPL Admin', 'Compliance'])
    );
  }

  private getActiveAzureLogin() {
    return this.loginRecords.find(
      (login) => login.userRoleActive?.toLowerCase() === 'yes' && !!login.azureUUID
    );
  }

  openInactivateConfirm(): void {
    const dialogConfig: DialogConfig = {
      title: 'Confirmation',
      isOkText: 'Yes',
      size: 'medium',
      position: 'top',
      showClose: true,
      showButtons: true,
    };

    this.dialogSvc.openDialog(
      this.confirmationDialog,
      dialogConfig,
      () => this.confirmInactivateAssociation(),
      () => this.handleInactivateCancel()
    );
  }

  handleInactivateCancel(): void {
  }

  confirmInactivateAssociation(): void {
    const providerId = this.storageService.getProviderId();
    const activeLogin = this.getActiveAzureLogin();
    const payload = {
      azureUUID: activeLogin?.azureUUID ?? null,
      userId: activeLogin?.userId ?? null,
      programCode: this.program.program_code,
    };

    this.leadDetailsService
      .inactivateAssociation(providerId, payload)
      .subscribe(() => {
        this.referralDataService.clearReferrralData();
        this.router.navigate(`/home/${this.userService.getFirstSegment()}`);
      });
  }

}
